import React, { ChangeEvent, useState } from 'react';
import { EventTypeInput } from '../../../types/ViewModel/EventTypeInput';
import { IntegerErrorWrapper, IntegerInputOuterWrapper, IntegerInputWrapper } from './IntegerInput.styles';
import './IntegerInput.styles';
import { InputFieldWrapper, InputHeadingWrapper, InputWrapper } from '../EventInput.styles';
import { resolveHeading } from '../../../utils/event/headingOverrides';
import eventInputUtils from '../../../utils/event/eventInputUtils';

type Props = {
    onChange: (ev: string | null, key: number, isEmpty: boolean, isValid: boolean) => void;
    evTypeInput: EventTypeInput;
    key: string;
};

const IntegerInputComponent: React.FC<Props> = (props) => {
    const [showErrorMessage, setShowErrorMessage] = useState<boolean>(false);
    const [integerErrorMessage, setIntegerErrorMessage] = useState<string | null>(null);
    const { isIntegerInputValid } = eventInputUtils();

    const isInputValid = (event: ChangeEvent<HTMLInputElement>): boolean => {
        if (event.target.value.length > 0) {
            let showError = false;
            const min = event.target.min !== '' ? event.target.min : null;
            const max = event.target.max !== '' ? event.target.max : null;
            const value = +event.target.value;

            if (min && value < +min) {
                setIntegerErrorMessage('Value must be higher or equal to ' + min);
                showError = true;
            }
            if (max && value > +max) {
                setIntegerErrorMessage('Value must be lower or equal to ' + max);
                showError = true;
            }
            setShowErrorMessage(showError);
            return !showError;
        } else {
            setShowErrorMessage(false);
        }
        return true;
    };

    const isNegativeNumberAllowed = (): boolean => {
        if (props.evTypeInput.inputDataTypeMaxMin) {
            return props.evTypeInput.inputDataTypeMaxMin.dataTypeIntMin < 0;
        }
        return true;
    };

    const isInputVerifiedRegEx = (regExStr: string, trigger: string): boolean => {
        // const rr = new RegExp('/-?\\d*/g');
        // const rr2 = trigger.match(rr);
        const regEx = new RegExp(regExStr);
        return regEx.test(trigger);
        // let reg1 = /^-?[0-9]*$/;
        // return reg1.test(trigger);
        //const regE = getRegexIntegerWithMinus();
        //var regx = trigger.match(regE);
        //const matchFound = trigger.match(regE);
    };

    const onNumberInputChange = (event: ChangeEvent<HTMLInputElement>) => {
        const inputString = event.target.value;
        event.preventDefault();

        const inpVerified = isInputVerifiedRegEx(event.target.pattern, inputString);

        if (inpVerified) {
            if (inputString === '-') {
                if (isNegativeNumberAllowed()) {
                    setShowErrorMessage(false);
                    props.onChange(inputString, props.evTypeInput.eventTypeInputId, false, false);
                } else {
                    setIntegerErrorMessage('Value must be higher or equal to ' + event.target.min);
                    setShowErrorMessage(true);
                    props.onChange(inputString, props.evTypeInput.eventTypeInputId, false, false);
                }
            } else {
                const isEmpty = inputString.length === 0;
                if (isInputValid(event)) {
                    props.onChange(inputString, props.evTypeInput.eventTypeInputId, isEmpty, true);
                } else {
                    props.onChange(inputString, props.evTypeInput.eventTypeInputId, isEmpty, false);
                }
            }
        }
    };

    const getRegexIntegerWithMinus = (): string => {
        let maxLength = 6;
        if (props.evTypeInput.inputDataTypeMaxMin && props.evTypeInput.inputDataTypeMaxMin.dataTypeIntMax) {
            maxLength = props.evTypeInput.inputDataTypeMaxMin.dataTypeIntMax.toString().length;
        }
        if (
            props.evTypeInput.inputDataTypeMaxMin &&
            props.evTypeInput.inputDataTypeMaxMin.dataTypeIntMin &&
            props.evTypeInput.inputDataTypeMaxMin.dataTypeIntMin < 0
        ) {
            if (maxLength < props.evTypeInput.inputDataTypeMaxMin.dataTypeIntMin.toString().length - 1) {
                maxLength = props.evTypeInput.inputDataTypeMaxMin.dataTypeIntMin.toString().length - 1;
            }
        }
        return '^-?\\d{0,' + maxLength + '}$';
    };

    const getRegexInteger = (): string => {
        return getRegexIntegerWithMinus();
    };

    const getMinValue = () => {
        if (props.evTypeInput.inputDataTypeMaxMin) {
            return props.evTypeInput.inputDataTypeMaxMin.dataTypeIntMin;
        }
        return undefined;
    };

    const getMaxValue = () => {
        if (props.evTypeInput.inputDataTypeMaxMin) {
            return props.evTypeInput.inputDataTypeMaxMin.dataTypeIntMax;
        }
        return undefined;
    };

    const getValue = (): string | null => {
        if (props.evTypeInput.eventTypeInputReg) {
            if (props.evTypeInput.eventTypeInputReg.intValueRegStr) {
                return props.evTypeInput.eventTypeInputReg.intValueRegStr;
            }
        }
        return null;
    };

    const checkIsValid = (evTypeInp: EventTypeInput, str: string | null): boolean => {
        return isIntegerInputValid(evTypeInp, str);
    };

    const inputElem = () => {
        return (
            <IntegerInputWrapper isNotValid={!checkIsValid(props.evTypeInput, getValue() ?? null)}>
                <input
                    type="text"
                    pattern={getRegexInteger()}
                    key={props.evTypeInput.eventTypeInputId}
                    onChange={onNumberInputChange}
                    min={getMinValue()}
                    max={getMaxValue()}
                    value={getValue() ?? ''}
                    className="number"
                    autoComplete="off"
                />
            </IntegerInputWrapper>
        );
    };

    const getErrorMessage = () => {
        return integerErrorMessage;
    };

    const errorMessageElem = () => {
        if (showErrorMessage) {
            return (
                <IntegerErrorWrapper>
                    <span>{getErrorMessage()}</span>
                </IntegerErrorWrapper>
            );
        }
        return null;
    };

    return (
        <>
            <InputWrapper>
                <InputHeadingWrapper>{resolveHeading(props.evTypeInput)}:</InputHeadingWrapper>
                <InputFieldWrapper>
                    <IntegerInputOuterWrapper>
                        {inputElem()}
                        {errorMessageElem()}
                    </IntegerInputOuterWrapper>
                </InputFieldWrapper>
            </InputWrapper>
        </>
    );
};

export default IntegerInputComponent;
